import * as yup from 'yup';

export const validationSchema = yup.object({
  code: yup
    .string()
    .trim()
    .length(6)
    .required(),
});
